import { SaleFilterValues } from "./SaleFilterValues";

export const buildSaleFilterPayload = (filters: SaleFilterValues): Record<string, any> => {
    const payload: Record<string, any> = {};
    if (filters.documentType) payload.documentTypeId = filters.documentType;
    if (filters.documentNumber) payload.documentNumber = filters.documentNumber;
    if (filters.customerId) payload.customerId = filters.customerId;
    if (filters.saleDate) payload.saleDate = filters.saleDate;
    if (filters.total) payload.total = filters.total;
    if (filters.status) payload.status = filters.status;
    if (filters.includeDraftCancelled) payload.includeDraftCancelled = true;
    return payload;
};
